import styled from 'styled-components';
import { Box } from '../../CommonComponents/OPL/Box/Box';

export const TilesGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(238px, 1fr))',
  gridAutoRows: 200,
  gap: 16,
});
